<template>
  <div class="web-shop-body">
    <div class="shop-banner">
      <h1 class="banner-header">
        {{ $t("label.select") }}: {{ selectedCategory.name }}
      </h1>
      <VSelect
        :items="webshopCategories"
        item-text="name"
        v-model="selectedCategory"
        varient="outlined"
        return-object
      />
    </div>
    <div class="webshop-products">
      <ProductGrid
        :products="products"
        :loading="loading"
        :authenticated="false"
        @loadProducts="loadProducts"
      />
    </div>
  </div>
</template>

<script>
import ProductGrid from "../../../portal/pages/Webshop/components/ProductGrid.vue";
export default {
  name: "Overview",
  components: {
    ProductGrid
  },
  mounted() {
    this.loadCategories();
    this.loadProducts();
  },
  data() {
    return {
      products: [],
      offset: 0,
      webshopCategories: [{ name: this.$t("label.all"), uuid: null }],
      selectedCategory: { name: this.$t("label.all"), uuid: null },
      allProductsLoaded: false,
      loading: false
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    selectedCategory: function() {
      this.allProductsLoaded = false;
      this.next_page_url = null;
      this.products = [];
      this.loadProducts();
    }
  },

  methods: {
    loadCategories() {
      this.$store.dispatch("product/getCategories").then(response => {
        response.data.forEach(new_category => {
          this.webshopCategories.push({
            name: new_category.name,
            uuid: new_category.uuid
          });
        });
      });
    },
    loadProducts() {
      if (this.allProductsLoaded || this.loading) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("product/getProducts", {
          next_page_url: this.next_page_url,
          category: this.selectedCategory.uuid
        })
        .then(response => {
          this.products.push(...response.data);
          if (!response.headers.get("Next-Page-Url")) {
            this.allProductsLoaded = true;
            this.next_page_url = null;
          } else {
            this.next_page_url = response.headers.get("Next-Page-Url");
          }
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.web-shop-body {
  padding: 20px;
}

.shop-banner {
  padding: 20px;
}

.shop-banner .v-select {
  width: 25rem;
}
</style>
